// Przycisk instalacji APP (funkcja starej APP, wygląd z klocków pakietu): na ekranie logowania „Zainstaluj jako
// aplikację” (znika w zainstalowanej), w menu (boczne i arkusz „Więcej”) zawsze widoczny („Aplikacja zainstalowana” po
// instalacji). Bez natywnego okna przeglądarki - instrukcja z wyborem Android / iPhone / Komputer, treść ta sama
// co ścieżka „Instalacja aplikacji” asystenta (INSTALACJA z api/czat_sciezki.go). Android - pobranie aplikacji
// TermometrWifi zamiast PWA (instalacja.ts androidBezPwa). W aplikacji ze sklepu go nie ma.
import { useState } from "react";
import { INSTALACJA } from "../gen/kontrakt";
import { t } from "../i18n/t";
import { Segmenty } from "./Filtry";
import { IkonaPobierz } from "./ikony";
import { androidBezPwa, instaluj, natywna, platforma, zainstalowana, type Platforma } from "./instalacja";

/** Plik aplikacji na Androida (Worker APP `pobierzAndroid`). */
export const POBIERZ_ANDROID = "/pobierz/android";
import { Okno } from "./Okno";
import { Przycisk } from "./Przyciski";

export function PrzyciskInstalacji({ miejsce, onOtwarte }: {
  miejsce: "logowanie" | "menu" | "wiecej";
  /** Po kliknięciu (np. zamknięcie arkusza „Więcej” przed oknem instrukcji) */
  onOtwarte?: () => void;
}) {
  const [okno, ustawOkno] = useState(false);
  const android = androidBezPwa();
  const juz = zainstalowana() && !android; // PWA zainstalowana na Androidzie przed 29.10 - też prowadzi do aplikacji
  if (natywna() || (juz && miejsce === "logowanie")) return null;
  const klik = () => {
    onOtwarte?.();
    void instaluj().then((ok) => ok || ustawOkno(true));
  };
  const napis = android ? t("Pobierz aplikację") : juz ? t("Aplikacja zainstalowana") : t("Zainstaluj aplikację");
  return (
    <>
      {miejsce === "logowanie" ? (
        <Przycisk wariant="cichy" pelny ikona={IkonaPobierz} onClick={klik} data-test="instaluj">
          {android ? t("Pobierz aplikację na Androida") : t("Zainstaluj jako aplikację")}</Przycisk>
      ) : (
        <button type="button" className={miejsce === "menu" ? "iot-nav-link" : "iot-wiecej__kafel"} onClick={klik} disabled={juz}
          data-test="instaluj">
          <IkonaPobierz />
          <span className="iot-nav-link__etykieta">{napis}</span>
        </button>
      )}
      <OknoInstalacji otwarte={okno} onZmianaOtwarcia={ustawOkno} />
    </>
  );
}

function OknoInstalacji({ otwarte, onZmianaOtwarcia }: { otwarte: boolean; onZmianaOtwarcia: (o: boolean) => void }) {
  const [p, ustawP] = useState<Platforma>(platforma);
  const w = INSTALACJA[p];
  return (
    <Okno otwarte={otwarte} onZmianaOtwarcia={onZmianaOtwarcia} tytul={t("Zainstaluj aplikację")}      akcje={<Przycisk wariant="glowny" onClick={() => onZmianaOtwarcia(false)}>{t("Rozumiem")}</Przycisk>}>
      <div className="iot-stos">
        <Segmenty etykieta={t("Na czym instalujesz?")} wartosc={p} onZmien={ustawP} pelne opcje={[
          { wartosc: "android", etykieta: t("Android") }, { wartosc: "iphone", etykieta: t("iPhone / iPad") },
          { wartosc: "komputer", etykieta: t("Komputer") }]} />
        <ol className="iot-numerowana">
          {w.kroki?.map((k) => <li key={k}>{t(k)}</li>)}
        </ol>
        {w.uwaga && <p className="iot-cichy iot-maly">{t(w.uwaga)}</p>}
        {p === "android" && (
          <a className="iot-btn iot-btn--glowny iot-btn--pelny" href={POBIERZ_ANDROID} data-test="pobierz-android">
            {t("Pobierz aplikację na Androida")}
          </a>
        )}
      </div>
    </Okno>
  );
}
